var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCollapseChevrons = function SvgCollapseChevrons(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26897 4.33224L2.28414 11.7404C2.01433 12.0266 2.01433 12.4734 2.28414 12.7596L9.26897 20.1678C9.8044 20.7356 10.7032 20.7489 11.2551 20.197C11.7816 19.6704 11.7973 18.8218 11.2906 18.2761L5.69495 12.25L11.2906 6.22388C11.7973 5.67824 11.7816 4.82956 11.2551 4.30304C10.7032 3.75115 9.8044 3.76436 9.26897 4.33224ZM19.269 4.33224L12.2841 11.7404C12.0143 12.0266 12.0143 12.4734 12.2841 12.7596L19.269 20.1678C19.8044 20.7356 20.7032 20.7489 21.2551 20.197C21.7816 19.6704 21.7973 18.8218 21.2906 18.2761L15.6949 12.25L21.2906 6.22388C21.7973 5.67824 21.7816 4.82956 21.2551 4.30304C20.7032 3.75115 19.8044 3.76436 19.269 4.33224Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.285714
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCollapseChevrons, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/collapse_chevrons.5bf29bbd.svg";
export { ForwardRef as ReactComponent };